import i18next from 'i18next';
import React from 'react';

import { CreateCompanyRequest } from '../../../../../../typings/api/skymap/rest/v0/company';
import {
  mapLanguageCodeToCountryCode,
  SupportedLanguage,
} from '../../../../utils/text/translation';

export type Company = {
  name: string;
  countryCode: NonNullable<CreateCompanyRequest['countryCode']>;
  orgOrVatNumber?: string;
  address: string;
  zipCode: string;
  city: string;
};

export type Administrator = {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
};

const defaultCompanyValues = (): Company => ({
  countryCode: mapLanguageCodeToCountryCode(i18next.language as SupportedLanguage),
  address: '',
  city: '',
  name: '',
  zipCode: '',
});

const defaultAdministratorValues: Administrator = {
  email: '',
  firstName: '',
  lastName: '',
  phone: '',
};

export const FormStateContext = React.createContext<{
  admin: Administrator;
  company: Company;
  setAdmin: (admin: Administrator) => void;
  setCompany: (company: Company) => void;
  reset: () => void;
}>(undefined!);

type Props = {
  children: React.ReactNode;
};

const FormState = (props: Props) => {
  const [company, setCompany] = React.useState<Company>(defaultCompanyValues());
  const [admin, setAdmin] = React.useState<Administrator>(defaultAdministratorValues);

  const render = () => {
    return (
      <FormStateContext.Provider
        value={{
          admin,
          company,
          setAdmin,
          setCompany,
          reset: () => {
            setCompany(defaultCompanyValues());
            setAdmin(defaultAdministratorValues);
          },
        }}
      >
        {props.children}
      </FormStateContext.Provider>
    );
  };

  return render();
};

export { FormState };
